import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import SectionCard from "./SectionCard";
import { ANIMATE } from "../utils/motion";

/** A compact column chart where each bar takes the color of its category. */
export default function BarsCard({ title, subtitle, slices: rawSlices, colors, shortLabels, height = 220 }) {
  // Long category names would overlap on the axis, so callers can pass short ones.
  const slices = shortLabels
    ? rawSlices.map((s) => ({ ...s, label: shortLabels[s.key] || s.label }))
    : rawSlices;
  return (
    <SectionCard title={title} subtitle={subtitle} sx={{ height: "100%" }}>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={slices} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
          <CartesianGrid vertical={false} stroke="rgba(15,23,42,0.07)" />
          <XAxis
            dataKey="label"
            tickLine={false}
            axisLine={false}
            tick={{ fontSize: 12, fill: "#64748B" }}
            interval={0}
          />
          <YAxis allowDecimals={false} tickLine={false} axisLine={false} tick={{ fontSize: 12, fill: "#64748B" }} />
          <Tooltip
            cursor={{ fill: "rgba(79,70,229,0.06)" }}
            contentStyle={{ borderRadius: 12, border: "none", boxShadow: "0 8px 24px rgba(15,23,42,.15)" }}
          />
          <Bar dataKey="count" name="Count" radius={[8, 8, 0, 0]} maxBarSize={46} isAnimationActive={ANIMATE}>
            {slices.map((s) => (
              <Cell key={s.key} fill={colors[s.key] || "#94A3B8"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </SectionCard>
  );
}
